import axios from "./axios";

export default {
  getByWarehouse(params) {
    const options = {
      method: "GET",
      url: "inventory_warehouse_locations",
      headers: { "content-type": "application/json" },
      params,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.message));
    });
  },

  create(data) {
    const options = {
      method: "POST",
      url: "inventory_warehouse_locations",
      headers: { "content-type": "application/json" },
      data,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.message));
    });
  },

  update(id, data) {
    const options = {
      method: "PUT",
      url: `inventory_warehouse_locations/${id}`,
      headers: { "content-type": "application/json" },
      data,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.message));
    });
  },

  delete(id, data = {}) {
    const options = {
      method: "DELETE",
      url: `inventory_warehouse_locations/${id}`,
      headers: { "content-type": "application/json" },
      data,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.message));
    });
  },

  assign(data) {
    const options = {
      method: "POST",
      url: "inventory_warehouse_locations/assign",
      headers: { "content-type": "application/json" },
      data,
    };

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.message));
    });
  },
};
